define('services/api',[
    'moment', 'utils',
    // 'env',
], function(moment, U) {

    var API_ENDPOINT = window.env.API_ENDPOINT;

    var API = {
        root: API_ENDPOINT + (API_ENDPOINT.slice(-1) !== '/' ? '/' : ''),
        url: function(url) {
            return this.root + url;
        },

        format: {
            date: 'YYYY-MM-DD',

            // 2016-09-21T21:47:09+00:00
            timestamp: 'YYYY-MM-DDTHH:mm:ssZ',
        },
        formatDate: function(date) {
            return moment(date).format(this.format.date);
        },
        formatTimeStamp: function(date) {
            return moment(date).format(this.format.timestamp);
        },
    };
    return API;
});

